export default __webpack_public_path__ + "static/media/closed.08f05fef.svg";